import {PortalConfiguration} from "./PortalConfiguration.js";

/**
 * This is to be copied from the etc/config.js in the production environment
 */

export const PortalConfig:PortalConfiguration = {
	APIUrl: "/api.php/",
	language: "en",
	frontendUrl: "/",
	title: "Entrance Portal",
	// sectionId: 1, //Sets a fixed section for this frontend
	// defaultSectionId: 9,
	//singleCertificateSectionId: 1 //Will print only a single certificate button that uses this section ID. The certificate should print all sections if this is used. (FrieslandCampina)
	participant: {
		requireEmail: true,
		requireCompany: false,
		skipEmailForSection: true
	},
	logClientErrors: false
} as const;